import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getAgentLanguages } from './api';
import { useParams } from 'react-router-dom';

export function useGetAgentLanguages(options?: UseQueryOptions<{ data: string[] }, Error>) {
  const { workspaceId, agentId } = useParams<{ workspaceId: string; agentId: string }>();
  return useQuery<{ data: string[] }>({
    queryKey: ['agency_languages', workspaceId, agentId],
    queryFn: () => getAgentLanguages(workspaceId, agentId),
    enabled: Boolean(workspaceId && agentId),
    ...options
  });
}
